var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex-box fl-between"},[_c('div',[_c('div',{staticClass:"info-noticeimg"},[_c('img',{attrs:{"alt":"image","src":this.img}})]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(this.type))])]),_vm._v(" "),_c('span',{staticClass:"notice-time"},[_vm._v(_vm._s(this.time))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"notice"},[_c('span',{staticClass:"notice-text"},[_c('span',[_vm._v(_vm._s(this.text))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11259724","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice/NoticeItem.vue
// module id = 839
// module chunks = 1